import { mapMutations, mapGetters, mapActions } from "vuex";
import { email, maxLength, minLength, required } from "vuelidate/lib/validators";

export default {
    name: "restore-form",
    data() {
        return {
            payload: {
                email: "",
                phone: "",
            },
            restoreBy: "email",
            validationErrors: {},
        };
    },
    validations() {
        if (this.restoreBy === "email") {
            return {
                payload: {
                    email: {
                        required,
                        maxLength: maxLength(50),
                        email,
                    },
                },
            };
        } else {
            return {
                payload: {
                    phone: {
                        required,
                        minLength: minLength(19),
                    },
                },
            };
        }
    },
    components: {},
    computed: {
        ...mapGetters({
            restoreLoading: "auth/restorePasswordLoading",
            showRestorePassword: "auth/showRestorePassword",
        }),
        emailErrors() {
            let error = [];
            if (!this.$v.payload.email.$dirty) {
                return error;
            }
            if (!this.$v.payload.email.maxLength) {
                error.push(this.$t("validationMax") + " 50");
            }
            if (!this.$v.payload.email.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.email.email) {
                error.push(this.$t("validationEmail"));
            }
            if (this.validationErrors.email) {
                this.validationErrors.email.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        phoneErrors() {
            let error = [];
            if (!this.$v.payload.phone.$dirty) {
                return error;
            }
            if (!this.$v.payload.phone.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.phone.minLength) {
                error.push(this.$t("validationLengthPhone"));
            }
            if (this.validationErrors.phone) {
                this.validationErrors.phone.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        disableButton() {
            if (this.restoreBy === "email") {
                if (this.payload.email === "") {
                    return true;
                }
                return false;
            } else {
                if (this.payload.phone === "") {
                    return true;
                }
                return false;
            }
        },
    },
    methods: {
        ...mapActions({
            restorePassword: `auth/RESTORE_PASSWORD`,
        }),
        ...mapMutations({
            changeRestorePassword: `auth/CHANGE_POPUP_RESTORE_PASSWORD`,
        }),
        changeToPhone() {
            this.restoreBy = "email";
            this.payload.phone = "";
            this.$nextTick(() => {
                this.$v.$reset();
            });
        },
        changeToEmail() {
            this.restoreBy = "phone";
            this.payload.email = "";
            this.$nextTick(() => {
                this.$v.$reset();
            });
        },
        submit() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                let obj = {};
                if (this.restoreBy === "email") {
                    obj.email = this.payload.email;

                    this.restorePassword(obj)
                        .then(() => {
                            this.changeRestorePassword(false);
                            this.$toasted.success(this.$t("sendMessageRestorePasswordByEmail")).goAway(5000);
                        })
                        .catch(error => {
                            if (error.response.status === 418) {
                                this.$toasted.error(error.response.data.message);
                            }
                            if (error.response.status === 400) {
                                this.$toasted.error(error.response.data.message);
                            }
                        });
                } else {
                    obj.phone = this.payload.phone.replace(/[\s.,%()-]/g, "");
                    this.restorePassword(obj)
                        .then(() => {
                            this.$toasted.success(this.$t("successSendCode"));
                            // console.log('restore phone2')
                            this.changeRestorePassword(false);
                            this.$router.replace({ query: { phone: `${obj.phone}` } }).catch(() => {
                                console.log();
                            });
                        })
                        .catch(error => {
                            if (error.response.status === 418) {
                                this.$toasted.error(error.response.data.message);
                            }
                            if (error.response.status === 400) {
                                this.$toasted.error(error.response.data.message);
                            }
                        });
                }
            }
        },
    },
};
